// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import type { ColumnType, Selectable, Insertable, Updateable } from 'kysely';
import { z } from 'zod';

/** Identifier type for public.user */
export type UserId = string & { __brand: 'public.user' };

/** Represents the table public.user */
export default interface UserTable {
  id: ColumnType<UserId, UserId | undefined, UserId>;

  email: ColumnType<string, string, string>;

  password: ColumnType<string, string, string>;

  _created_at: ColumnType<string, string | undefined, string>;
}

export type User = Selectable<UserTable>;

export type NewUser = Insertable<UserTable>;

export type UserUpdate = Updateable<UserTable>;

export const userId = z.string() as unknown as z.Schema<UserId>;

export const user = z.object({
  id: userId,
  email: z.string(),
  password: z.string(),
  _created_at: z.string(),
}) as unknown as z.Schema<User>;

export const userInitializer = z.object({
  id: userId.optional(),
  email: z.string(),
  password: z.string(),
}) as unknown as z.Schema<UserInitializer>;

export const userMutator = z.object({
  id: userId.optional(),
  email: z.string().optional(),
  password: z.string().optional(),
}) as unknown as z.Schema<UserMutator>;
